<template>
  <div class="home-wrapper">
    <div class="action-bar">
      <div class="icon-user" @click="handleUserCenter" v-if="userInfo && userInfo.avatar" :style="{backgroundImage: `url(${userInfo.avatar})`}"></div>
      <div class="icon-user" @click="handleUserCenter" v-else></div>
      <span class="choose-member" @click="handleChooseMember" v-if="members && members.length > 0">{{curMember && curMember.name}} <img src="../../assets/img/down.png" alt="" class="icon-down"></span>
    </div>
    <router-view/>
    <van-popup v-model="showMemberPicker" round position="bottom">
      <van-picker
              show-toolbar
              :columns="members"
              visible-item-count="3"
              :default-index="indexShowMember"
              value-key="name"
              @cancel="showMemberPicker = false"
              @confirm="handleConfirm"/>
    </van-popup>
  </div>
</template>

<script>
import {mapState, mapMutations} from 'vuex';
export default {
  name: 'Home',
  data() {
    return {
      showMemberPicker: false,
      indexShowMember: 0
    }
  },
  computed: {
    curMember() {
      if (this.members.length === 0) return undefined;
      return this.members[this.indexShowMember];
    },
    ...mapState([
            'userInfo',
            'members',
            'selectMemberId',
            'isIgnoreMobile'
    ])
  },

  watch: {
    members(val) {
      this.indexShowMember = this.findMemberIndexById(val, this.selectMemberId);
    },
    selectMemberId(val) {
      this.indexShowMember = this.findMemberIndexById(this.members, val);
    },
    // curMember(val) {
    //   if (!val) {
    //     return;
    //   }
    //   if (val.hasReport) {
    //     if (this.$route.path === '/home/addReportHome') {
    //       this.$router.replace('/home/index');
    //     }
    //   } else {
    //     if (this.$route.path === '/home/index') {
    //       this.$router.replace('/home/addReportHome?memberId=' + val.id);
    //     }
    //   }
    // }
  },

  methods: {
    handleConfirm(value, idx) {
      this.setSelectMemberId(this.members[idx].id);
      this.showMemberPicker = false;
    },
    handleChooseMember() {
      this.showMemberPicker = true;
    },
    handleUserCenter() {
      this.$router.push('/userCenter');
    },

    handleAddMember() {
      this.$router.push('/member');
    },

    findMemberIndexById(members, memberId) {
      let index = members.findIndex(item => item.id === memberId);
      return Math.max(0, index);
    },

    goPage() {
      if (!this.userInfo.deviceId) {
        this.$router.replace('/home/bindingDevice', null, () => {})
      } else if(!this.userInfo.mobile && !this.isIgnoreMobile){
        this.$router.replace('/home/bindingMobile', null, () => {})
      }else if (this.members.length === 0){
        this.$router.replace('/home/addMember', null, () => {})
    //  } else if (!this.curMember.hasReport){
     //   this.$router.replace('/home/addReportHome?memberId=' + this.curMember.id, null, () => {})
      } else {
        this.$router.replace('/home/index', null, () => {})
      }
    },

    ...mapMutations([
            'setSelectMemberId'
    ])
  },
  mounted() {
    this.indexShowMember = this.findMemberIndexById(this.members, this.selectMemberId);
    this.goPage();
  }
}
</script>
